<template>
    <div class="main">
        <c-panel title="CARTEIRINHAS ESCOLARES" titleIcon="fas fa-id-card">
            <el-alert title="Carteirinha no formato cartão 85×54mm (ISO ID-1), 8 por página A4. A foto cadastrada no aluno/servidor é impressa; sem foto, aparece um espaço cinza."
                type="info" :closable="false" class="u-mb-15"></el-alert>

            <el-form label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Tipo de carteirinha">
                            <el-select v-model="aba" placeholder="Selecione o tipo" style="width:100%;">
                                <el-option label="Aluno individual" value="alunoIndividual"></el-option>
                                <el-option label="Alunos por turma" value="alunoTurma"></el-option>
                                <el-option label="Professor individual" value="profIndividual"></el-option>
                                <el-option label="Todos da instituição" value="loteInstituicao"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <!--
                Perfil de rede (4, 5, 6, 7, 8, 10) não tem escola no contexto: o seletor do
                header só existe para perfis de escola. Sem este campo, "Alunos por turma" e
                "Todos da instituição" ficavam impossíveis para quem administra a rede — a
                mensagem mandava escolher no header, onde não havia o que escolher.
            -->
            <el-form v-if="ehRede" label-position="top">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="24" :md="24">
                        <el-form-item label="Instituição">
                            <el-select v-model="instituicaoSelecionada" filterable clearable
                                       placeholder="Selecione a instituição" style="width:100%;"
                                       @change="carregarTurmas">
                                <el-option v-for="i in instituicoes" :key="i.id" :label="i.nome" :value="i.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="aba === 'alunoIndividual'" class="u-mt-15">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :sm="24">
                            <el-form-item label="Aluno">
                                <el-select v-model="alunoId" filterable remote :remote-method="buscarAluno" :loading="loadAluno"
                                    placeholder="Digite o nome..." style="width:100%;">
                                    <el-option v-for="a in alunos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" style="padding-top:24px; text-align: right;">
                            <el-button type="primary" icon="el-icon-printer" :disabled="!alunoId" @click="imprimirAluno">GERAR CARTEIRINHA</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-if="aba === 'alunoTurma'" class="u-mt-15">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :sm="24">
                            <el-form-item label="Turma">
                                <el-select v-model="turmaId" filterable placeholder="Selecione" style="width:100%;">
                                    <el-option v-for="t in turmas" :key="t.id" :label="t.nome" :value="t.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" style="padding-top:24px; text-align: right;">
                            <el-button type="primary" icon="el-icon-printer" :disabled="!turmaId" @click="imprimirTurma">GERAR LOTE</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-if="aba === 'profIndividual'" class="u-mt-15">
                <el-form label-position="top">
                    <el-row :gutter="10">
                        <el-col :sm="24">
                            <el-form-item label="Servidor (professor)">
                                <el-select v-model="servidorId" filterable remote :remote-method="buscarServidor" :loading="loadServidor"
                                    placeholder="Digite o nome..." style="width:100%;">
                                    <el-option v-for="s in servidores" :key="s.id" :label="s.nome" :value="s.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" style="padding-top:24px; text-align: right;">
                            <el-button type="primary" icon="el-icon-printer" :disabled="!servidorId" @click="imprimirProfessor">GERAR CARTEIRINHA</el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </div>

            <div v-if="aba === 'loteInstituicao'" class="u-mt-15">
                <p>Gera carteirinhas em lote para todos os alunos ativos OU todos os professores docentes da instituição selecionada.</p>
                <div style="text-align: right;">
                    <el-button-group>
                        <el-button type="primary" icon="el-icon-printer" @click="imprimirLoteInst('aluno')">TODOS OS ALUNOS</el-button>
                        <el-button type="success" icon="el-icon-printer" @click="imprimirLoteInst('professor')">TODOS OS PROFESSORES</el-button>
                    </el-button-group>
                </div>
            </div>
        </c-panel>
    </div>
</template>

<script>
export default {
    data () {
        return {
            aba: 'alunoIndividual',
            alunoId: null, alunos: [], loadAluno: false,
            servidorId: null, servidores: [], loadServidor: false,
            turmaId: null, turmas: [],
            instituicoes: [], instituicaoSelecionada: null
        }
    },
    computed: {
        /** Perfis de abrangência de rede — os que não têm escola no contexto. */
        ehRede () {
            const t = parseInt(this.$store.state.user ? this.$store.state.user.tipo : null)
            return t === 10 || (t > 3 && t <= 8)
        }
    },
    mounted () {
        if (this.ehRede) this.carregarInstituicoes()
        this.carregarTurmas()
    },
    watch: {
        '$store.state.config.instituicao.id' () { this.carregarTurmas() }
    },
    methods: {
        baseUrl () { return this.$store.state.config.baseUrlApi },
        /** A escola escolhida na tela tem precedência sobre a do contexto. */
        instId () {
            if (this.instituicaoSelecionada) return this.instituicaoSelecionada
            const i = this.$store.state.config.instituicao
            return i && i.id ? i.id : null
        },
        carregarInstituicoes () {
            this.$axios.get(`${this.baseUrl()}/api/instituicao/getAll`, this.$store.getters.getHeaderAuth)
                .then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : Object.values(r.data || {}) })
                .catch(() => { this.instituicoes = [] })
        },

        buscarAluno (q) {
            if (!q || q.length < 2) { this.alunos = []; return }
            this.loadAluno = true
            this.$axios.post(`${this.baseUrl()}/api/aluno/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.alunos = r.data || []; this.loadAluno = false })
                .catch(() => { this.loadAluno = false })
        },
        buscarServidor (q) {
            if (!q || q.length < 2) { this.servidores = []; return }
            this.loadServidor = true
            this.$axios.post(`${this.baseUrl()}/api/servidor/searchByNome`, { query: q }, this.$store.getters.getHeaderAuth)
                .then(r => { this.servidores = r.data || []; this.loadServidor = false })
                .catch(() => { this.loadServidor = false })
        },
        /**
         * `api/turma/getAllPaginate` NÃO EXISTE — a rota nunca foi criada. A chamada voltava
         * 404 sem cabeçalho de CORS, o `catch` engolia e o select de turma ficava vazio para
         * todo mundo, não só para perfil de rede.
         *
         * `getAllTurmas/{i}/{p}` é a rota real, e devolve um OBJETO agrupado por nome de
         * curso — não um array. Daí o achatamento.
         */
        carregarTurmas () {
            this.turmas = []

            const inst = this.instId()
            const periodo = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

            if (!inst || !periodo) return

            this.$axios.get(`${this.baseUrl()}/api/turma/getAllTurmas/${inst}/${periodo}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const d = r.data || {}
                this.turmas = Array.isArray(d)
                    ? d
                    : Object.keys(d).reduce((acc, curso) => acc.concat(d[curso] || []), [])
            }).catch(() => { this.turmas = [] })
        },

        abrirPdf (url) {
            this.$axios.get(url, { ...this.$store.getters.getHeaderAuth, responseType: 'blob' })
                .then(r => {
                    // Quando o backend retorna {erro:'...'} em 200 OK, o body chega como blob
                    // application/json — não tentar abrir como PDF. Lê texto e exibe alert.
                    const tipo = (r.headers && (r.headers['content-type'] || r.headers['Content-Type'])) || ''
                    if (tipo.indexOf('application/json') !== -1) {
                        const reader = new FileReader()
                        reader.onload = () => {
                            try {
                                const obj = JSON.parse(reader.result)
                                const msg = (obj && obj.erro)
                                    ? (typeof obj.erro === 'string' ? obj.erro : obj.erro.text || JSON.stringify(obj.erro))
                                    : 'Falha ao gerar PDF.'
                                window.eventBus.$emit('alert', { msg, type: 'warning' })
                            } catch (e) {
                                window.eventBus.$emit('alert', { msg: 'Falha ao gerar PDF.', type: 'warning' })
                            }
                        }
                        reader.readAsText(r.data)
                        return
                    }
                    const blob = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }))
                    window.open(blob, '_blank')
                })
                .catch(e => this.$store.commit('throwException', e))
        },
        imprimirAluno ()   { this.abrirPdf(`${this.baseUrl()}/api/carteirinha/aluno/${this.alunoId}`) },
        imprimirProfessor () { this.abrirPdf(`${this.baseUrl()}/api/carteirinha/professor/${this.servidorId}`) },
        imprimirTurma ()   { this.abrirPdf(`${this.baseUrl()}/api/carteirinha/loteTurma/${this.turmaId}`) },
        imprimirLoteInst (tipo) {
            if (!this.instId()) { window.eventBus.$emit('alert', { msg: 'Selecione a instituição antes de gerar o lote.', type: 'warning' }); return }
            this.abrirPdf(`${this.baseUrl()}/api/carteirinha/loteInstituicao/${this.instId()}?tipo=${tipo}`)
        }
    }
}
</script>
